export default __webpack_public_path__ + "static/media/notification-white.affda891.svg";